
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 26"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.881 8.524a1.009 1.009 0 00-.892-.536h-2.873a2.886 2.886 0 00-2.836-2.376 2.886 2.886 0 00-2.836 2.376h-2.91c.228-.35.362-.766.362-1.214A2.227 2.227 0 005.67 4.55a2.227 2.227 0 00-2.224 2.224c0 .448.133.865.361 1.214H1.436a1.01 1.01 0 00-.84 1.575l6.785 10.089v5.727a.505.505 0 00.708.463l4.65-2.025a.505.505 0 00.304-.464v-3.701l6.785-10.089c.209-.31.229-.709.053-1.04zm-6.6-1.901c.855 0 1.579.578 1.8 1.365H11.48a1.873 1.873 0 011.8-1.365zM5.67 5.56c.67 0 1.214.544 1.214 1.213a1.215 1.215 0 01-2.427 0c0-.669.544-1.213 1.213-1.213zm6.447 13.654a.506.506 0 00-.086.282v3.525l-3.64 1.585v-4.604h1.827a.506.506 0 100-1.011H8.156l-5.088-7.567H13.28a.505.505 0 100-1.01H2.388l-.952-1.416h17.552l-6.87 10.216zM11.938 0a2.227 2.227 0 00-2.225 2.224c0 1.227.998 2.225 2.225 2.225a2.227 2.227 0 002.224-2.225A2.227 2.227 0 0011.937 0zm0 3.438a1.215 1.215 0 01-1.214-1.214c0-.669.544-1.213 1.213-1.213.67 0 1.214.544 1.214 1.213 0 .67-.544 1.214-1.213 1.214zM17.34 2.444a.506.506 0 00-.505.505v2.873a.506.506 0 001.011 0V2.95a.506.506 0 00-.506-.505zM17.698.932a.51.51 0 00-.715 0 .51.51 0 000 .715.51.51 0 00.715 0 .51.51 0 000-.715zM7.39.645a.506.506 0 00-.505.505v2.073a.506.506 0 101.01 0V1.15A.506.506 0 007.39.645zM.506 0A.506.506 0 000 .506V3.8a.506.506 0 101.011 0V.506A.506.506 0 00.506 0zM.863 5.339A.507.507 0 000 5.696a.51.51 0 00.506.506.51.51 0 00.505-.506.508.508 0 00-.148-.357z"}}),_c('path',{attrs:{"d":"M15.886 10.563a.51.51 0 00-.715 0 .507.507 0 000 .714.508.508 0 00.715 0 .51.51 0 000-.714z"}})])
          )
        }
      }
    